(function() {
    'use strict';
    angular.module('app')
        .controller('ResellerNetworkServiceProfilesController', ResellerNetworkServiceProfilesController);
    ResellerNetworkServiceProfilesController.$inject = ['ClientService', '$routeParams','Carrier', 'toastr', 'SharedServiceProfilesTableService', '$q'];
    function ResellerNetworkServiceProfilesController(ClientService, $routeParams, Carrier, toastr, SharedServiceProfilesTableService, $q){
        let vm = this;
        vm.id = $routeParams.id;
        vm.carrierProfileId = $routeParams.carrierProfileId;
        (()=>{
            vm.isFetching = true;
            getCarrierProfile().then(data=>{
                vm.carrierProfile = data;
                const initCalls = {
                    reseller: getClientDetails(),
                    services: getServices(vm.carrierProfile.carrier.id)
                }
                $q.all(initCalls).then(function (data) {
                    vm.details = data.reseller;
                    vm.sharedServiceProfilesTable = new SharedServiceProfilesTableService(data.services, vm.carrierProfileId).tableData;
                    vm.isFetching = false;
                }).catch(error=>{
                    onAPIError(error);
                });
            }).catch(error=>{
                onAPIError(error);
            });
            function onAPIError(error) {
                vm.isFetching = false;
                vm.fetchError = true;
                toastr.error(error.message);
            }
        })();

        function getClientDetails() {
            const defer = $q.defer();
            ClientService.Company.get(vm.id, data=>{
                defer.resolve(data);
            }, error=>{
                defer.reject(error);
            });
            return defer.promise;
        }
        function getCarrierProfile() {
            const defer = $q.defer();
            Carrier.getExternalCarrierProfile(vm.carrierProfileId,data=>{
                defer.resolve(data);
            },error=>{
                defer.reject(error);
            });
            return defer.promise;
        }
        function getServices(carrierId) {
            const defer = $q.defer();
            Carrier.getCarriers(function(data) {
                defer.resolve(data.find(carrier=>{
                    return carrier.id === carrierId
                }).services);
            }, function(err) {
                defer.reject(err);
            });
            return defer.promise;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/networking/ResellerNetworkServiceProfilesController.js